// Lightweight shared state for the i18n debug overlay
// Avoids threading additional params through many functions and keeps tests simple

let overlayMeta = {}

export function setOverlayMeta(meta) {
  overlayMeta = meta || {}
}

export function getOverlayMeta() {
  return overlayMeta || {}
}
